module.exports = __webpack_public_path__ + "img/aac.f40c1a2f.svg";